import request, { apiService2 } from '../utils/request';


export function pVentasRequest(data) {
    return request({
        url: 'dashboard/pventas',
        method: 'post',
        data
    })
}

export async function invoicesRequest(data) {
  const pventa = data.pventa?.trim();
  
  if (!pventa) {
    const [res1, res2] = await Promise.all([
        request({ url: 'dashboard/invoices', method: 'post', data }),
        apiService2.post('dashboard/invoices', data),
    ]);

    return {
        data: {
            data: [
                ...(res1.data?.data || []),
                ...(res2.data?.data || [])
            ]
        }
    };
  }

  if (urlsConfig.api2.includes(pventa)) {
    return apiService2.post('dashboard/invoices', data);
  } else {
    return request({ url: 'dashboard/invoices', method: 'post', data });
  }
}

// export function findAllRequest(data) {
//     return request({
//         url: 'dashboard/findAll/invoices',
//         method: 'post',
//         data
//     })
// }

// Listas de pventas según API
const urlsConfig = {
    api2: [
        'mimos-hospitalpablotobonuribe',
        'mimos-cityplaza',
        'mimos-primaveraurbana',
        'mimos-citymedica',
        'mimos-vivavillavicencio',
        'mimos-ipiales',
        'mimos-parqueguarne',
        'mimos-estrella',
        'mimos-jardin',
        'mimos-florida',
        'mimos-santafe',
        'mimos-fabricato3',
        'mimos-puertadelnorte',
        'mimos-eurolafrontera',
        'mimos-florencia',
        'mimos-santuario',
        'mimos-plazabeillin',
        'mimos-vegasplaza',
        'macheticos-santafe',
        'mimos-aventura',
        'mimos-carmendeviboral',
        'macheticos-fabricato',
        'macheticos-sannicolas',
        'macheticos-mayorca',
        'macheticos-plazabeillin',
        'mimos-vivawajira',
        'macheticos-mallotraparte',
        'mimos-bosqueplaza',
        'mimos-eltesoro',
        'mimos-aeropuertopalmira',
        'mimos-bicentenario',
        'macheticos-lacentral',
        'mimos-plazadelrio',
        'macheticos-aventura',
        'mimos-guatapuri',
        'macheticos-terminaldelnorte',
        'macheticos-aguacatala',
        'macheticos-llanogrande',
        'mimos-nuestrouraba',
        'mimos-fabricato2',
        'mimos-jauladelangel',
        'mimos-laestacion',
        'mimos-plazaflora',
        'mimos-multicentro',
        'mimos-lemont',
        'mimos-parqueexplora',
        'mimos-florida2',
        'mimos-diamante',
        'macheticos-diamante',
        'mimos-distritovera'
    ], 
};

export async function findAllRequest(data) {
  const pventa = data.pventa?.trim();

  if (!pventa) {
    const [res1, res2] = await Promise.all([
      request({ url: 'dashboard/findAll/invoices', method: 'post', data }),
      apiService2.post('dashboard/findAll/invoices', data),
    ]);
    return {
      data: {
        data: [...(res1.data.data || []), ...(res2.data.data || [])],
      },
    };
  }

  if (urlsConfig.api2.includes(pventa)) {
    return apiService2.post('dashboard/findAll/invoices', data);
  } else {
    return request({ url: 'dashboard/findAll/invoices', method: 'post', data });
  }
}

export function typeInvoicesRequest(data) {
    return request({
        url: `dashboard/invoices/by/pventa`,
        method: 'post',
        data
    })
}

export function updateInvoicesRequest(data) {
    return request({
        url: `/check-in/update`,
        method: 'post',
        data
    })
}

export function ErrosInvoicesRequest(data) {
    return request({
        url: `/check-in/errors`,
        method: 'post',
        data
    })
}
